import { useState } from 'react';
import { NotConnected } from 'src/components/shared';
import { RootStackScreenProps } from 'src/core';

const NotConnectedScreen = ({ navigation }: RootStackScreenProps<'NotConnected'>) => {
  const [loading, setLoading] = useState<boolean>(false);
  return (
    <NotConnected
      loading={loading}
      onRetry={() => {
        setLoading(true);
        setTimeout(() => {
          navigation.navigate('NotConnected');
          setLoading(false);
        }, 250);
      }}
    />
  );
};

export default NotConnectedScreen;
